import { CLINICARD_NAMES } from 'constants/constants';
import logo from 'assets/images/logo.svg';
import logo_payoff from 'assets/images/logo_payoff.svg';

export default {
  APP_TITLE: 'Clinicards',
  ENABLE_CE: false,
  ENABLE_CONSENT: false,
  ENABLE_GDPR: true,
  ENABLE_PROSTHESIS_PASSPORT: false,
  ENABLE_EXTERNAL_LINKS: false,
  ENABLE_CARETEAM: true,
  ENABLE_CARETEAM_SHARED: true,
  ENABLE_MY_CLINICARDS: false,
  ENABLE_SETTINGS: true,
  ENABLE_PATIENTS: true,
  ENABLE_CLINICARDS: true,
  ENABLE_ARTICLES: false,
  ENABLE_CAREPATH: false,
  ENABLE_PERSONAL_MESSAGES: false,
  ENABLE_MEDICAL_PROFILE: false,
  ENABLE_OPERATION_PROFILE: false,
  ENABLE_MANAGEMENT: false,
  ENABLE_INCLUSION: false,
  ENABLE_DIRECT_CAREUSER: false,
  ENABLE_INSTITUTIONS: false,
  ENABLE_ORGANISATION_LEVEL: false,
  ENABLE_ORGANISATION_DETAILS: false,
  ENABLE_CHILD_PROFILE: false,
  ENABLE_INSIGHTS: true,
  ENABLE_STICKY_CAREPATHITEM: false,
  ENABLE_ACTIVATIONPERIOD_CAREPATHITEM: false,
  ENABLE_RANDOMISATION: false,
  // By default, questionnaires do NOT have Insights graph
  INSIGHTS_GRAPH_WHITELIST: [],
  // By default, healthcards DO have a graph
  INSIGHTS_GRAPH_BLACKLIST: [CLINICARD_NAMES.PHOTO, CLINICARD_NAMES.GOALS],
  // Set to enable push notifications
  ONESIGNAL_APP_ID: '',
  ONESIGNAL_API_URL: 'https://onesignal.com/api/v1/notifications',
  SERVICE_DESK_EMAIL: 'support@clinicards.io',
  logo,
  logo_payoff,
  MANUAL_URL: {
    nl: 'https://clinicards-nl.refined.site',
    en: 'https://clinicards-en.refined.site',
  },
  DEFAULTCARDS: [],
  DEFAULTCAREPATH: undefined,
};
